import { useCallback } from "react";

import { defaultStore } from "shared/common/stores/defaultStore";

export function useForwardPointerEvents(
  onForwardedPointerEvent?: (e: React.PointerEvent) => void,
  onClose?: (event: {}, reason: "backdropClick" | "escapeKeyDown") => void
) {
  const viewer = defaultStore((state) => state.viewer);

  return useCallback(
    (e: React.PointerEvent) => {
      if (!viewer) return;
      const canvas = viewer.getCanvas();
      const nativeEvent = e.nativeEvent;

      if (nativeEvent.type === "pointerdown") {
        canvas.setPointerCapture(nativeEvent.pointerId);
      }

      const eventInit: PointerEventInit = {
        bubbles: true,
        cancelable: true,
        composed: true,
        pointerId: nativeEvent.pointerId,
        pointerType: nativeEvent.pointerType,
        clientX: nativeEvent.clientX,
        clientY: nativeEvent.clientY,
        screenX: nativeEvent.screenX,
        screenY: nativeEvent.screenY,
        buttons: nativeEvent.buttons,
        pressure: nativeEvent.pressure,
        isPrimary: nativeEvent.isPrimary,
        width: nativeEvent.width,
        height: nativeEvent.height,
        tiltX: nativeEvent.tiltX,
        tiltY: nativeEvent.tiltY,
        twist: nativeEvent.twist,
      };

      const forwardedEvent = new PointerEvent(e.type, eventInit);
      canvas.dispatchEvent(forwardedEvent);

      if (nativeEvent.type === "pointerdown" && onClose) {
        onClose({}, "backdropClick");
      }

      if (onForwardedPointerEvent) onForwardedPointerEvent(e);
    },
    [viewer, onForwardedPointerEvent, onClose]
  );
}
